import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { PscWithVendorsDataModel } from '../../models/PscWithVendorsDataModel';
import { UnspscCodeWithVendorsDataModel } from '../../models/UnspscCodeWithVendorsDataModel';
import { VendorWithProductCountModel } from '../../models/VndorWithProductCountModel';
import { BaseApiService } from '../base-api.service';
import { PSCData } from '../cccReport/ccc-report.service';
import { SyncCodeData } from '../SearchParameters/search-parameters.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class ParametersService {
  baseUrl = window.location.origin;
  token = '';

  public UnspscsWithVendors: BehaviorSubject<UnspscCodeWithVendorsDataModel[]>;
  public PscsWithVendors: BehaviorSubject<PscWithVendorsDataModel[]>;
  public SyncCodeData: BehaviorSubject<SyncCodeData[]>;

  constructor(
    private baseApiService: BaseApiService,
    private user: UserService,
  ) {
    this.UnspscsWithVendors = new BehaviorSubject<
      UnspscCodeWithVendorsDataModel[]
    >([]);
    this.PscsWithVendors = new BehaviorSubject<PscWithVendorsDataModel[]>([]);
    this.SyncCodeData = new BehaviorSubject<SyncCodeData[]>([]);

    this.user.token.subscribe(token => {
      this.token = token;
    });
  }

  GetAllUnspscCodes(): Promise<UnspscCode[]> {
    let url = this.baseUrl + '/api/parameters/GetAllUnspscCodes';
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.get<UnspscCode[]>(url);
  }

  GetAllPscs(): Promise<PSCData[]> {
    let url = this.baseUrl + '/api/parameters/GetAllPscs';
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.get<PSCData[]>(url);
  }

  GetSyncCodes(): Promise<SyncCodeData[]> {
    let url = this.baseUrl + '/api/TypeAheadData/GetSyncCodes';
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.get<SyncCodeData[]>(url);
  }

  public GetVendorsByUnspscCode(
    unspscCode: string,
  ): Promise<VendorWithProductCountModel[]> {
    let url = this.baseUrl + '/api/parameters/GetVendorsByUnspscCode';
    let model = { unspsc: unspscCode };
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.getTU<VendorWithProductCountModel[]>(url, model);
  }

  public GetVendorsByPSCDescription(
    pscDescription: string,
  ): Promise<VendorWithProductCountModel[]> {
    let url =
      this.baseUrl + '/api/parameters/GetVendorsByProductSpendCategoryName';
    let model = { psc: pscDescription };
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.getTU<VendorWithProductCountModel[]>(url, model);
  }

  public GetVendorsBySyncSubcategory(
    syncSubcategory: string,
  ): Promise<VendorWithProductCountModel[]> {
    let url = this.baseUrl + '/api/parameters/GetVendorsBySyncSubcategory';
    let model = { sync: syncSubcategory };
    this.baseApiService.headerToken = this.token;
    return this.baseApiService.getTU<VendorWithProductCountModel[]>(url, model);
  }
}

export class UnspscCode {
  code: string;
  description: string;
}
